// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"Projects__wrapper__3JE3y","aboutHeading":"Projects__aboutHeading__MNCYR","projectBlock":"Projects__projectBlock__1D_3u","projectCont":"Projects__projectCont__3GLbM","middle":"Projects__middle__2oQqc","text":"Projects__text__2nj_K"};


//////////////////
// WEBPACK FOOTER
// ./src/Components/Projects/Projects.css
// module id = 38
// module chunks = 0